import { render, staticRenderFns } from "./IconProject.vue?vue&type=template&id=47ecc534&"
import script from "./IconProject.vue?vue&type=script&lang=ts&"
export * from "./IconProject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports